import React from 'react';
import './offers.scss';

import {IsRole_Admin, IsRole_Manager, IsRole_Operator,IsRole_SalesManager} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 
import { createStore } from 'devextreme-aspnet-data';
import CustomStore from "devextreme/data/custom_store";
import {Button as ToolbarButton} from 'devextreme-react/button';
import {Popup as SinglePopup} from 'devextreme-react/popup';

import DataGrid, {
    Column,
    Export,
    Popup,
    Form,
    Button,
    Pager,
    Paging,
    FilterRow,
    HeaderFilter,
    RowDragging,
    Lookup,
    Item,
    Toolbar,
    Editing,
    Selection,
    Summary,
    Format,
    //GroupItem,
    TotalItem,
    SearchPanel
  } from 'devextreme-react/data-grid';

//import { Item} from 'devextreme-react/form';
import { useState, useEffect, useCallback, useRef } from "react";
import { formatNumber } from 'devextreme/localization';
import notify from "devextreme/ui/notify";

import  {Form as SingleForm,Label,Item as FormItem,ButtonItem,GroupItem} from 'devextreme-react/form';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaDettaglio'
const debug = process.env.ENTITY_DEBUG;
/*
function setTipoRigaValue(rowData, value) {
    rowData.categoriaId = null;
    rowData.articoloId = null;
    this.defaultSetCellValue(rowData, value); 
};
*/

function setCategoriaValue(rowData, value) {
  rowData.articoloId = null;
  this.defaultSetCellValue(rowData, value); 
};

export default function OfferDetailBuy(props) {

    const filterPayload = { 
        idSuper: props.myKey,
        noNotes: true
    };

    //console.log("STATOID:" + props.status);

    const [tipiArticolo, setTipiArticolo] = useState({});
    const [um, setUm] = useState({});
    const [articoli, setArticoli] = useState({});
    const [imposte, setImposte] = useState({});
    const [categorie, setCategorie] = useState({});

    const [currentRow, setCurrentRow] = useState(1);
    const [currentRowData, setCurrentRowData] = useState([]);
    const [isRowSelected, setIsRowSelected] = useState(false);
    const [applyToAll, setApplyToAll] = useState(false);
    const { user } = useAuth(); 

    const isAdmin=IsRole_Admin();
    //console.log('IsAdmin: ' + isAdmin);
  
    const isSalesManager=IsRole_SalesManager();


    const [isPopupVisible, setPopupVisibility] = useState(false);
    const togglePopup = () => {
      setPopupVisibility(!isPopupVisible);
    };

    const [extendedData, setExtendedData] = useState({});
    const [isPopupVisible2, setPopupVisibility2] = useState(false);
    const togglePopup2 = () => {
      setPopupVisibility2(!isPopupVisible2);
    };


    useEffect(() => {

        const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
        var newUrl =  newServiceUrl + "/GetAction";

        const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
        var newUrl2 =  newServiceUrl2 + "/GetAction";

        const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Articoli';
        var newUrl3 =  newServiceUrl3 + "/GetAction";

        const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
        var newUrl4 =  newServiceUrl4 + "/GetAction";

        const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ArticoloCategoria';
        var newUrl5 =  newServiceUrl5 + "/GetAction";

        const fetchData = async () => {
            try {

                const response = await fetch(newUrl);
                const json = await response.json();
                if (debug === 1)
                  console.log(json);
                setTipiArticolo(json);

                const response2 = await fetch(newUrl2);
                const json2 = await response2.json();
                if (debug === 1)
                  console.log(json2);
                setUm(json2);

                const response3 = await fetch(newUrl3);
                const json3 = await response3.json();
                if (debug === 1)
                  console.log(json3);
                setArticoli(json3);

                const response4 = await fetch(newUrl4);
                const json4 = await response4.json();
                if (debug === 1)
                  console.log(json4);
                setImposte(json4);

                const response5 = await fetch(newUrl5);
                const json5 = await response5.json();
                if (debug === 1)
                  console.log(json5);
                setCategorie(json5);

            } catch (error) {
                console.log("error", error);
            }
        };
        fetchData();
    }, []);

    async function getArticle(id)  {

        if (id == null)
          id = 0;
        
          var serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Articolo/GetAction/' + id;
    
        const requestOptions = {
          method: 'GET',
          //body: JSON.stringify(t),
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${this.state.loggedUser.token}`
          }
        };
    
        return fetch(serviceUrl, requestOptions)
        .then(response => {
          if(response.ok) return response.json();
          //Global.CheckResponseAuth(response);
          return null;
        })
    
        .then(data => { 
          return data;
        })
        .catch(error => { notify(error, 'error', 5000); }); 
    }

    async function setArticleValues(newData, value, currentRowData) {

        console.log("ARTICOLO: " + value);
        return getArticle(value).then(data => {
          newData.articoloId = value;
          newData.codice = data.codice;
          newData.codiceAlias = data.codiceFornitore;
          newData.paUnitario = data.prezzoAcquisto;
          newData.descrizione = data.descrizione;
          newData.impostaId = data.impostaId;
          newData.tipoRigaId = data.tipoArticoloId;
          newData.umid = data.umid;
          newData.paSconto = 0;
          newData.paScontato = 0;
          newData.paTotale = 0;
          newData.quantità= 1;
          newData.pvPercRicarico = data.percRicarico;
      });
    }


    function customizeText(data) {
        return `Righe: ${data.value}`;
    }

    function customizeData(data) {
        return `PA Totale: ${formatNumber(data.value, '###,##0.00')}`;
    }

    function onInitNewRow(e) {
        //e.data.offertaId = props.data.key;
        e.data.offertaId = props.myKey;
    };

    
    const onEditorPreparing = (e) => {
        if (e.parentType === "dataRow" && e.dataField === "articoloId") {
           //e.editorOptions.disabled = typeof e.row.data.tipoRigaId !== "number";
           e.editorOptions.disabled = typeof e.row.data.categoriaId !== "number";
           //notify(error, 'Modificato', 5000);
           //notify(`Modificato`, { type: 'warning' });
        }
    }
/*
    const getFilteredArticoli = (options) => {
        return {
          store: articoli,
          filter: options.data ? ['tipoRigaId', '=', options.data.tipoArticoloId] : null,
        };
    };
*/
    const getFilteredArticoli = useCallback(
        (options) => {
          return {
            key: "id",
            store: new CustomStore({
              load: function (loadOptions) {
                // fake call server to get the list of article
                return new Promise((resolve) => {
                  setTimeout(() => {
                    const res = loadOptions.filter
                      ? articoli.filter((c) => c.categoriaId === options.data.categoriaId)
                      : articoli;
                    resolve(res);
                  }, 500);                
                });
              },
              byKey: function (key) {
                return new Promise((resolve) => {
                  resolve(articoli.find((c) => c.id === key));
                });
              }
            }),
            filter: options.data ? ["categoriaId", "=", options.data.categoriaId] : null
          };
        },
        [articoli]
      );

/*      
      const getFilteredCategorie = useCallback(
        (options) => {
          return {
            key: "id",
            store: new CustomStore({
              load: function (loadOptions) {
                // fake call server to get the list of article
                return new Promise((resolve) => {
                  setTimeout(() => {
                    const res = loadOptions.filter
                      ? categorie.filter((c) => c.tipoId === options.data.tipoRigaId)
                      : categorie;
                    resolve(res);
                  }, 500);                
                });
              },
              byKey: function (key) {
                return new Promise((resolve) => {
                  resolve(categorie.find((c) => c.id === key));
                });
              }
            }),
            filter: options.data ? ["tipoRigaId", "=", options.data.tipoArticoloId] : null
          };
        },
        [categorie]
      );


      const getFilteredArticoliByTipo = useCallback(
        (options) => {
          return {
            key: "id",
            store: new CustomStore({
              load: function (loadOptions) {
                // fake call server to get the list of article
                return new Promise((resolve) => {
                  setTimeout(() => {
                    const res = loadOptions.filter
                      ? articoli.filter((c) => c.tipoArticoloId === options.data.tipoRigaId)
                      : articoli;
                    resolve(res);
                  }, 500);                
                });
              },
              byKey: function (key) {
                return new Promise((resolve) => {
                  resolve(articoli.find((c) => c.id === key));
                });
              }
            }),
            filter: options.data ? ["tipoRigaId", "=", options.data.tipoArticoloId] : null
          };
        },
        [articoli]
      );
*/

    const remoteDataSource = createStore({

        key: 'id',
        loadUrl: serviceUrl + '/Find',
        
        onBeforeSend: (method, ajaxOptions) => {
            if (method == "load" ) {    
                console.log("CHIAVE: " + filterPayload.idSuper);       
                var payload = ajaxOptions.data;
                payload.values = JSON.stringify(filterPayload);
                ajaxOptions.data = payload;          
            }  
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
        ;
        },
        insertUrl: serviceUrl + '/InsertAction',
        updateUrl:serviceUrl + '/UpdateAction',
        deleteUrl: serviceUrl + '/DeleteAction'
        
    });

    function onReorder(e) {
      e.promise = processReorder(e);
    }
  
    async function processReorder(e) {
      
      const visibleRows = e.component.getVisibleRows();
      const newOrderIndex = visibleRows[e.toIndex].data.orderIndex;
  
      await remoteDataSource.update(e.itemData.id, { orderIndex: newOrderIndex });
      await e.component.refresh();
    }
  

    function calculatePATotale(rowData) {
        return (rowData.paUnitario - (rowData.paUnitario / 100 * rowData.paPercSconto)) * rowData.quantità;
    };

    function onRowInserting(e) {
      e.data.createBy = user.name;
    };
  
    function onRowUpdating(e) {
      e.newData.updateBy = user.name;
    };

    function onToolbarPreparing(e) {
      var item = e.toolbarOptions.items.find(item => item.name === "addRowButton"); 
          if(!allowModify())
              item.options.visible = false;
  };

  function allowModify() {
    //se  Marketing (1) o RDO (10) o Persa (4) o Non Processata (5) possono modificarla tutti altrimenti se Completata(11) solo il ruolo admin o salesmanager
    if((props.status === 1 || props.status === 10 || props.status === 4 || props.status === 5 ) || ((isAdmin || isSalesManager) &&  (props.status === 11)))
      return true
    else
      return false     
  };

  const closeButtonOptions = {
    text: 'Annulla',
    width: '100px',
    type: '',
    onClick: function () {
      setPopupVisibility(!isPopupVisible);
      setApplyToAll(false);
    }
  };

    const closeButtonOptions2 = {
      text: 'Annulla',
      width: '100px',
      type: '',
      onClick: function () {
        setPopupVisibility2(false);
      }
    };

    const submitButtonOptions = {
      text: 'Salva',
      width: '100px',
      type: 'default',
      useSubmitBehavior: true,
    };

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data !== null && data !== undefined) {
      setCurrentRow(data.id);
      setIsRowSelected(true);
      setCurrentRowData(data);
      //setExtendedData(data.proprietaEstese ?? {});
      //console.log("PROP ESTESE: " + data.proprietaEstese)
    } else {
      setIsRowSelected(false);
    }
  }

  const handleSubmit = (e) => {
    setPopupVisibility(!isPopupVisible);
    e.preventDefault();
    const detail = {
      Id: currentRowData.id,
      RifOffertaFornitore: currentRowData.rifOffertaFornitore,
      ArticoloId: currentRowData.articoloId,
      ApplyToAllFromSupplier: applyToAll, // stato separato
    };
    onSaveButtonClick(detail);
    setApplyToAll(false);
  }; 




  async function onSaveButtonClick(detail) {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaDettaglio/UpdateDettaglio';

    // 🔎 Debug info
    //console.log("📡 URL chiamato:", url);
    //console.log("📦 Body inviato:", detail);
    //console.log("🔑 Token:", user?.token);

    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(detail),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user?.token}`
      }
    };

    try {
      const response = await fetch(url, requestOptions);

      //console.log("📡 Response status:", response.status);

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Errore ${response.status}: ${text}`);
      }

      const data = await response.json();
      //console.log("✅ Response JSON:", data);

      notify(data.message, data.success ? 'success' : 'error', 3000);

      return data;
    } catch (error) {
      //console.error("❌ Errore fetch:", error);
      notify(error.message, 'error', 5000);
    }
  }


  const renderContent = () =>  {

    const article = articoli.find((c) => c.id === currentRowData.articoloId);
    return (
      <>       
        <p>{article?.descrizioneEstesa}</p>
        <form   onSubmit={handleSubmit} action="#">
          <SingleForm
            
            id="form"
            formData={currentRowData}
          >
         
            <FormItem dataField="id" visible={false}></FormItem>
            <FormItem dataField="rifOffertaFornitore">
              <Label text={`Rif.Offerta Fornitore`} />
            </FormItem>  
           <FormItem
              editorType="dxCheckBox"
              editorOptions={{
                text: "Applica ad altri articoli dello stesso fornitore",
                value: applyToAll,
                onValueChanged: (e) => setApplyToAll(e.value),
              }}
            />

            <FormItem itemType="empty" colSpan={2} />
            <GroupItem colCount={2} cssClass="buttons-group">
              <ButtonItem  horizontalAlignment="right" buttonOptions={closeButtonOptions} />
              <ButtonItem  horizontalAlignment="left" buttonOptions={submitButtonOptions} />
            </GroupItem>
          
          </SingleForm>
        
        </form>
      </>            
    )
  }

  const handleSubmit2 = (e) => {

    console.log("extendedData completo:", extendedData);
    console.log(Object.keys(extendedData));
    e.preventDefault();

    const values = formRef.current.instance().option("formData");

    const detail = {
        Id: currentRowData.id,
        LunghezzaTratta: values.lunghezzaTratta,
        NumeroBobine: values.numeroBobine,
        Schermo: values.schermo
    };

    onSaveButtonClick2(detail);
    setPopupVisibility2(false);
};


  async function onSaveButtonClick2(detail) {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaDettaglio/UpdateProprietaEstese';

    // 🔎 Debug info
    //console.log("URL chiamato:", url);
    //console.log("Body inviato:", detail);
    //console.log("Token:", user?.token);

    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(detail),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user?.token}`
      }
    };

    try {
      const response = await fetch(url, requestOptions);

      //console.log("Response status:", response.status);

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Errore ${response.status}: ${text}`);
      }

      const data = await response.json();
      notify(data.message, data.success ? 'success' : 'error', 3000);

      return data;
    } catch (error) {
      notify(error.message, 'error', 5000);
    }
  }

  const formRef = useRef(null);
  const showPopup2 = () => {

    let props = {};

    if (currentRowData?.proprietaEstese) {
        props = JSON.parse(currentRowData.proprietaEstese);
        console.log("PE:" + currentRowData?.proprietaEstese)
    }

    setExtendedData(props);
    setPopupVisibility2(true);
  }

  const extendedFields = [
    {
        field: "lunghezzaTratta",
        label: "Lunghezza tratta (metri)",
        type: "number"
    },
    {
        field: "numeroBobine",
        label: "Numero bobine",
        type: "number"
    },
    {
        field: "schermo",
        label: "Schermo",
        type: "text"
    }
  ];


  const renderContent2 = () => {

    //const formData = currentRowData.proprietaEstese ?? {};
    const article = articoli.find(c => c.id === currentRowData.articoloId);

    return (
        <>
          <p>{article?.descrizioneEstesa}</p>

            <form onSubmit={handleSubmit2} action="#">
                <SingleForm
                    id="form"
                    ref={formRef}
                    formData={extendedData}
                     //formData={formData}
                >

                    {extendedFields.map(f => (
                        <FormItem
                            key={f.field}
                            dataField={f.field}
                            label={{ text: f.label }}
                            editorType={
                                f.type === "number"
                                    ? "dxNumberBox"
                                    : "dxTextBox"
                            }
                        />
                    ))}

                    <GroupItem colCount={2} cssClass="buttons-group">
                        <ButtonItem
                            horizontalAlignment="right"
                            buttonOptions={closeButtonOptions2}
                        />
                        <ButtonItem
                            horizontalAlignment="left"
                            buttonOptions={submitButtonOptions}
                        />
                    </GroupItem>

                </SingleForm>
            </form>
        </>
    );
};

return (
  
    
    <div>
        <DataGrid id="grid-container"
            dataSource={remoteDataSource}
            showBorders={true}
            columnAutoWidth={true}
            onInitNewRow={onInitNewRow}
            onEditorPreparing={onEditorPreparing}
            onRowUpdating={onRowUpdating}
            onRowInserting={onRowInserting}
            onToolbarPreparing = {onToolbarPreparing}
            onSelectionChanged = {onRowSelectionChanged}
            dateSerializationFormat= {'yyyy-MM-dd'}
        >
          <Paging  defaultPageSize={40}/>
          <Pager showPageSizeSelector={true} showInfo={true} />

          <Toolbar>
            <Item name="addRowButton"  /> 
            <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='product'
                hint='Rif. Offerta Fornitore'
                onClick={togglePopup}
                disabled={!isRowSelected} />
          </Item>   
           <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='preferences'
                hint='Altri attributi'
                onClick={showPopup2}
                disabled={!isRowSelected} />
          </Item>   
          </Toolbar>

          <RowDragging
            allowReordering={true}
            onReorder={onReorder}
            dropFeedbackMode="push"
          />

          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <Summary>
                 
            <TotalItem
                column="codice"
                summaryType="count"
                customizeText={customizeText}
            />
            <TotalItem
              column="paTotale"
              summaryType="sum" 
              customizeText={customizeData}
              />
          </Summary>
            <Selection mode="single" />
          <Editing
            mode="row"
            allowUpdating={allowModify}
            allowAdding={allowModify}
            allowDeleting={allowModify}
            useIcons={true}
          >
          </Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="offertaId" visible={false}/>
            
            <Column dataField="categoriaId" caption="Categoria"  width={240} setCellValue={setCategoriaValue} >
                <Lookup dataSource={categorie} valueExpr="id" displayExpr="nome"/>
            </Column>
            <Column dataField="codiceAlias" caption="Codice" width={100} allowEditing={false}/>
    
            <Column dataField="articoloId" caption="Descrizione" width={480} setCellValue={setArticleValues}>
                <Lookup dataSource={getFilteredArticoli} valueExpr="id" displayExpr="descrizioneEstesa"/>
            </Column>
            <Column dataField="tipoRigaId" caption="Tipo"  width={60}  allowEditing={false}>
                <Lookup dataSource={tipiArticolo} valueExpr="id" displayExpr="codice"/>
            </Column>
            <Column dataField="impostaId" caption="IVA" width={60} allowEditing={false}>
                <Lookup dataSource={imposte} valueExpr="id" displayExpr="codice" />
            </Column> 
            <Column dataField="umid" caption="UM" width={60} allowEditing={false}>
                <Lookup dataSource={um} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="quantità" caption="Q.tà" width={80}/>
            <Column dataField="paUnitario" caption="PAi Unit." >
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="paPercSconto" caption="% Sconto" >
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="paScontato"  caption="PA Unit." >
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="paTotale" calculateCellValue={calculatePATotale} caption="PA Totale" allowEditing={false}>
                <Format type="fixedPoint" precision={2} />
            </Column> 
            <Column dataField="dataConsegna" dataType={'date'} format= {'dd/MM/yyyy'} caption="Data Consegna" />
            
            <Column
                caption=""
                width={36}
                cellRender={({ data }) => {
                if (!data.proprietaEstese) return null;
                return (
                    <i
                      className="dx-icon-preferences"
                      style={{ color: "#1498e4", fontSize: 18 }}
                      title={`Altri attributi`}
                    />
                );
                }}
            />

            <Column dataField="updateBy" visible={false}/>
            <Column dataField="createBy" visible={false}/> 
        </DataGrid>

        <div>
          <SinglePopup
            width={400}
            height={300} 
            showTitle={true}
            title="Rif. Offerta Fornitore"
            visible={isPopupVisible}
            hideOnOutsideClick={true}
            onHiding={togglePopup}
            contentRender={renderContent}
          > 
          </SinglePopup> 
        </div>

        <div>
          <SinglePopup
            width={400}
            height={360} 
            showTitle={true}
            title="Altri attributi"
            visible={isPopupVisible2}
            hideOnOutsideClick={true}
            onHiding={togglePopup2}
            contentRender={renderContent2}
          > 
          </SinglePopup> 
        </div>

    </div>   
   
)};